import React from 'react';
import Modal from '../../../../../../../components/Modal';
import Table from '../../../../../../../components/table/Table';
import columns from './columns';

const AccountUserDetailTagLogModal = (props) => {
  const { isOpen, data, closeModal, getAccountUserDetailTagLogList } = props;
  const { userId, tagId, tagLogHistory, userTagLogList } = data;
  const { filterOption, sortOption } = tagLogHistory;

  return (
    <Modal
      title="유저 태그 타임라인 리스트"
      isOpen={isOpen}
      width={620}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="account-user-detail-tag-timeline-modal">
        <Table
          data={userTagLogList}
          isStriped={true}
          emptyText="요청하신 검색 필터로 검색된 팔로우 태그 타임라인 리스트가 없습니다."
          filterOption={filterOption}
          sortOption={sortOption}
          getList={(data) =>
            getAccountUserDetailTagLogList({
              userId,
              tagId,
              tagLogHistory: {
                filterOption,
                sortOption,
                ...data,
              },
            })
          }
          columns={(utils) => columns(utils)}
        />
      </div>
    </Modal>
  );
};

export default AccountUserDetailTagLogModal;
